const messages = {
  it: {
    slot_full: "Non ci sono posti sufficienti per il numero di ospiti scelto. Seleziona un altro turno.",
    two_top_full: "I tavoli da 2 persone sono esauriti per questo turno. Scegli un altro orario o un'altra data.",
    past_slot: "La data o l'orario scelto è già passato. Seleziona un nuovo turno.",
    invalid_time: "Questo orario non è disponibile per la data scelta. Seleziona un altro turno.",
    invalid_date: "Seleziona una data valida.",
    lunch_sunday_only: "Il pranzo è disponibile solo la domenica. Scegli una domenica.",
    invalid_event: "Seleziona il tipo di evento e la fascia oraria.",
    request_processing: "La richiesta è ancora in elaborazione. Attendi qualche secondo e riprova: non verrà duplicata.",
    request_changed: "I dati della richiesta sono cambiati. Controllali e riprova.",
    network: "Connessione interrotta: non è stato possibile verificare l'invio. Controlla la connessione e riprova senza chiudere questa pagina.",
    server: "Il servizio non risponde al momento. Attendi qualche secondo e riprova senza chiudere questa pagina.",
    invalid: "Controlla i dati inseriti e riprova.",
    validation: "Controlla questi campi:",
    rate: (minutes) => `Troppe richieste ravvicinate. Riprova tra ${minutes} min.`,
  },
  en: {
    slot_full: "There are not enough seats for your party. Please choose another seating.",
    two_top_full: "Tables for 2 are fully booked for this seating. Please choose another time or date.",
    past_slot: "The selected date or time has passed. Please choose another seating.",
    invalid_time: "This time is not available on the selected date. Please choose another seating.",
    invalid_date: "Please select a valid date.",
    lunch_sunday_only: "Lunch is available on Sundays only. Please pick a Sunday.",
    invalid_event: "Please select the event type and time period.",
    request_processing: "Your request is still processing. Wait a few seconds and retry: it will not be duplicated.",
    request_changed: "Your request details have changed. Please check them and try again.",
    network: "Connection interrupted: we could not verify submission. Check your connection and retry without closing this page.",
    server: "The service is temporarily unavailable. Wait a few seconds and retry without closing this page.",
    invalid: "Please check your details and try again.",
    validation: "Please check these fields:",
    rate: (minutes) => `Too many requests. Please try again in ${minutes} min.`,
  },
};

const fields = {
  it: { nome: "nome", cognome: "cognome", email: "email", phone: "telefono", instagram: "profilo Instagram", guests: "numero di ospiti", date: "data", time: "orario", birthday: "compleanno", note: "note", event_budget: "budget (euro interi, da 0 a 10.000)", event_description: "descrizione evento", allergy_counts: "numero di persone con intolleranze" },
  en: { nome: "first name", cognome: "last name", email: "email", phone: "phone", instagram: "Instagram profile", guests: "party size", date: "date", time: "time", birthday: "birthday", note: "notes", event_budget: "budget (whole euros, 0–10,000)", event_description: "event description", allergy_counts: "allergy counts" },
};

export function bookingErrorMessage(error, lang = "it") {
  const locale = lang === "en" ? "en" : "it";
  const text = messages[locale];
  if (!error?.response) return text.network;
  const { status, data, headers } = error.response;
  const detail = data?.detail;
  if (status === 429 || detail?.code === "rate_limited") {
    const seconds = Number(headers?.["retry-after"] || detail?.retry_after || 60);
    return text.rate(Math.max(1, Math.ceil((Number.isFinite(seconds) ? seconds : 60) / 60)));
  }
  if (status >= 500) return text.server;
  if (Array.isArray(detail)) {
    const labels = [...new Set(detail.map((item) => fields[locale][item.loc?.[1]]).filter(Boolean))];
    return labels.length ? `${text.validation} ${labels.join(", ")}.` : text.invalid;
  }
  if (text[detail?.code] && typeof text[detail.code] === "string") return text[detail.code];
  if (typeof detail?.message === "string") return detail.message;
  return typeof detail === "string" && detail.trim() ? detail : text.invalid;
}